/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable import/exports-last */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable import/max-dependencies */
/* eslint-disable max-lines */
import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react'
import InstallAtShopInfo from './InstallAtShopInfo'
import useDifmAction from '../store/hooks/useDifmAction'
import InstallAtShopNoVehicle from './InstallAtShopNoVehicle'
import {
  getAllowedPartForDifm3, getKitType, getPartType, getPartTypeFromShop,
} from '../utility/allowedPartsForDifm3'
import { GTM } from '../../../helpers'
import DifmLocation from '../constants/DifmLocation'
import mapDifmModifierToInstallationShop, {
  mapInstallationShopToModifiers,
} from '../utility/mapDifmModifierToInstallationShop'
import IInstallationShopVehicle from '../models/IInstallationShopVehicle'
import useAddDifm from '../../ShoppingCartV2/hooks/actions/useAddDifm'
import useRemoveDifm from '../../ShoppingCartV2/hooks/actions/useRemoveDifm'
import { useShoppingCartContext } from '../../ShoppingCartV2/providers/ShoppingCartProvider'
import IInstallationShop from '../models/IInstallationShop'
import IDifmCart from '../models/IDifmCart'
import getIsCartItemAvailableForDifm from '../utility/getIsCartItemAvailableForDifm'
import { ICartItem } from '../models/ICart'
import useIsDifmEnabled from '../store/hooks/useIsDifmEnabled'
import useSuggestedShopForPart from '../store/hooks/useSuggestedShopForPart'
import useSuggestedShopForPartV2 from '../store/hooks/useSuggestedShopForPartV2'
import SkeletonLoaderInstallAtShopCart from '../SkeletonLoaderInstallAtShopCart/SkeletonLoaderInstallAtShopCart'
import findDeliveryDateForInstallAtShop from '../utility/findDeliveryDateForInstallAtShop'
import { useNrAttributeContext } from '../../../contexts/nrAttribute.context'
import { isFirstAvailableTimeslot } from '../utility/dateUtils'
import useValidateShopTimeslotsForItemVehicle from '../store/hooks/useValidateShopTimeslotsForItemVehicle'
import useIsRepairPalPricingEnabled from '../store/hooks/useIsRepairPalPricingEnabled'
import useAcesIdsCache from '../store/hooks/useAcesIdsCache'
import useAllowedPartsFlag from '../store/hooks/useAllowedPartsFlag'
import isSetFromVendorOnCart from '../utility/isSetFromVendorOnCart'
import IDrawerOpenedFrom from '../store/models/IDrawerOpenedFrom'
import IProductInfoForAces from '../store/models/IProductInfoForAces'
import { getFront, getVehicleImage, VEHICLE_IMAGE } from '../../../contexts/vehicleImage.context'
import { IDifmVehicle } from '../models/DifmVehicle'
import PartType from '../constants/PartType'
import { removeEmpty } from '../utility/objectUtils'
import InstallationQuotes from '../../Product/InstallationQuotes'

export interface IInstallAtShopCartProps {
  addVehicleTrigger: () => void,
  cartItemData: ICartItem
  lastSkuEta: string
}

const { installAtShopWidgetLoaded, rppPriceRange, rppSinglePrice } = GTM

const InstallAtShopCart: React.FC<IInstallAtShopCartProps> = props => {
  const {
    addVehicleTrigger,
    cartItemData,
    lastSkuEta,
  } = props

  const { allowedPartsForDifmMasterFilter } = useAllowedPartsFlag()
  const isAllowedForDifm = getIsCartItemAvailableForDifm(cartItemData, allowedPartsForDifmMasterFilter)
  const productId = cartItemData?.product?.productId
  const sku = cartItemData?.product?.sku
  const skuETA = useMemo(() => findDeliveryDateForInstallAtShop(cartItemData?.shippingOption?.options as any[], 'deliveryDate'),
    [cartItemData?.shippingOption?.options])

  const usedSkuEta = useMemo(() => {
    if (!lastSkuEta && !skuETA) {
      return ''
    }

    if (!lastSkuEta) {
      return skuETA
    }

    if (!skuETA) {
      return lastSkuEta
    }

    if (new Date(skuETA).getTime() > new Date(lastSkuEta).getTime()) {
      return skuETA
    }

    return lastSkuEta
  }, [lastSkuEta, skuETA])
  const difmCartItem = cartItemData?.modifiers?.difm

  const isSetFromVendor = useMemo(() => isSetFromVendorOnCart(cartItemData), [cartItemData])

  const vehicle = cartItemData?.modifiers?.vehicle?.details
  const partName = cartItemData?.product?.part?.name

  const installationShopVehicle: IInstallationShopVehicle = useMemo(() => removeEmpty({
    partName,
    partnerMakeId: '',
    make: vehicle?.make,
    year: vehicle?.year.toString(),
    model: vehicle?.model,
    submodel: vehicle?.submodel,
    isVehicleFit: cartItemData?.modifiers?.vehicle?.isFit,
    kitType: getKitType(sku, isSetFromVendor),
    acesIds: cartItemData?.modifiers?.vehicle?.acesIds,
  }) as IInstallationShopVehicle, [
    partName,
    cartItemData?.modifiers?.vehicle?.isFit,
    vehicle?.make,
    vehicle?.year,
    vehicle?.model,
    vehicle?.submodel,
    sku,
    isSetFromVendor,
    cartItemData?.modifiers?.vehicle?.acesIds,
  ])

  const { actions, difmState } = useDifmAction('Cart')
  const { suggestedShops, nearShopsPostalCode, difmApiVersionForPartsOnCart } = difmState

  const {
    openWizardForCartItem,
    selectInstallationShopAction,
    closeWizard, resetNearShops,
    deselectInstallation,
    openVehicleDetails,
  } = actions
  const isDifmEnabled = useIsDifmEnabled()

  const isRepairPalPricingEnabled = useIsRepairPalPricingEnabled(cartItemData?.product?.part?.name)

  const suggestedShop = isRepairPalPricingEnabled
    ? useSuggestedShopForPartV2(cartItemData?.product?.part?.name, sku, getPartType(sku, isSetFromVendor, null), installationShopVehicle)
    : useSuggestedShopForPart(cartItemData?.product?.part?.name, sku, isSetFromVendor)

  const installationShopFromCart = useMemo(() => mapDifmModifierToInstallationShop(difmCartItem || null, installationShopVehicle),
    [difmCartItem, installationShopVehicle])

  const [isInstallationAdded, setIsInstallationAdded] = useState(installationShopFromCart?.isSelected || false)

  const { setDifmAttr } = useNrAttributeContext()

  const installationShop: IInstallationShop | null = useMemo(() => {
    if (installationShopFromCart) {
      return installationShopFromCart
    }
    if (!suggestedShop) {
      return null
    }
    const isSelected = isInstallationAdded

    return {
      ...suggestedShop,
      isSelected,
      vehicle: {
        ...installationShopVehicle,
        acesIds: suggestedShop?.vehicle?.acesIds,
      },
    }
  }, [installationShopFromCart, suggestedShop, isInstallationAdded, installationShopVehicle])

  // eslint-disable-next-line no-nested-ternary
  const priceType = isRepairPalPricingEnabled && installationShop?.installPriceMin && installationShop?.installPriceMax ? 'range' : installationShop?.installPrice ? 'single' : null
  const isPriceRange = priceType === 'range'

  const addDifm = useAddDifm()
  const difmItemForCart = useMemo(() => mapInstallationShopToModifiers(installationShop as IInstallationShop),
    [installationShop])

  const openVehicleDrawer = useCallback(async (from: IDrawerOpenedFrom) => {
    if (!installationShop || !skuETA || !cartItemData?.modifiers?.vehicle?.details || !cartItemData?.product) {
      return null
    }
    const vehicleImages = await getVehicleImage(cartItemData?.modifiers?.vehicle?.details)

    const vehicleDetailsModified:IDifmVehicle = {
      ...cartItemData?.modifiers?.vehicle?.details,
      year: cartItemData?.modifiers?.vehicle?.details?.year?.toString(),
    }

    const productInfo: IProductInfoForAces = {
      vehicleDetailsOpenedFrom: from,
      productId: cartItemData?.product?.productId?.toString(),
      productImageUrl: cartItemData?.product?.image?.url || '',
      productSku: cartItemData?.product?.sku || '',
      productBrand: cartItemData?.product?.brand?.name || '',
      requiredOptions: installationShop.requiredOptions || [],
      vehicleImageUrl: getFront(vehicleImages, VEHICLE_IMAGE.secureUrl) as string,
      skuETA,
      vehicle: vehicleDetailsModified,
      partName: getAllowedPartForDifm3(cartItemData?.product?.part?.name) || '',
      partPosition: cartItemData?.product?.position || '',
      // TODO: replace it with getPartType() function
      partType: (cartItemData.product.kitType && cartItemData.product.kitType !== 'null' ? cartItemData?.product?.kitType : PartType.Component) as PartType,
    }

    return openVehicleDetails(productInfo)
  }, [cartItemData?.modifiers, cartItemData?.product, installationShop, skuETA, openVehicleDetails])

  const { findAcesIdsFromInstallationShopVehicle } = useAcesIdsCache()

  const acesIdsFromCartItemOrCache = useMemo(() => {
    if (installationShop?.vehicle?.acesIds) {
      return installationShop?.vehicle?.acesIds
    }

    const pageType = getPartTypeFromShop(installationShop)
    return findAcesIdsFromInstallationShopVehicle(partName, pageType, installationShop?.vehicle)
  },
  [findAcesIdsFromInstallationShopVehicle, installationShop, partName])

  const onAddFromCart = useCallback(
    () => {
      if (isPriceRange) {
        return openVehicleDrawer('addInstallationCart')
      }

      if (productId && difmItemForCart?.shopId && installationShop?.shopId) {
        setIsInstallationAdded(true)
        try {
          addDifm(productId, difmItemForCart, acesIdsFromCartItemOrCache, difmApiVersionForPartsOnCart || [])
        } catch {
          deselectInstallation()
        }
      }
      return null
    },
    [isPriceRange,
      productId,
      difmItemForCart,
      installationShop?.shopId,
      openVehicleDrawer,
      addDifm,
      acesIdsFromCartItemOrCache,
      difmApiVersionForPartsOnCart,
      deselectInstallation],
  )

  useEffect(() => () => {
    closeWizard()
  }, [closeWizard])

  const {
    getCartId,
    getIdentifier,
    setCart,
  } = useShoppingCartContext()

  const difmCart: IDifmCart = useMemo(() => ({
    cartId: getCartId() as any,
    identifier: getIdentifier(),
    setCart,
  }), [getCartId, getIdentifier, setCart])

  const onChangeFromCart = useCallback(
    () => {
      if (isPriceRange) {
        return openVehicleDrawer('changeAppointmentCart')
      }

      if (installationShop?.shopId && productId && difmCart.cartId) {
        openWizardForCartItem(installationShop, productId, difmCart, sku, getAllowedPartForDifm3(installationShopVehicle?.partName) as string, installationShopVehicle?.make || '', usedSkuEta)
        resetNearShops(nearShopsPostalCode)
      }
      return null
    },
    [isPriceRange,
      installationShop,
      productId,
      difmCart,
      openVehicleDrawer,
      openWizardForCartItem,
      sku,
      installationShopVehicle?.partName,
      installationShopVehicle?.make,
      usedSkuEta,
      resetNearShops,
      nearShopsPostalCode],
  )

  const removeDifm = useRemoveDifm()
  const onRemoveFromCart = useCallback(
    () => {
      if (productId && installationShop) {
        setIsInstallationAdded(false)
        removeDifm([productId])
        selectInstallationShopAction(false, installationShop, usedSkuEta, productId)
      }
    },
    [productId, installationShop, removeDifm, selectInstallationShopAction, usedSkuEta],
  )

  const serializedVehicle = useMemo(() => removeEmpty({
    year: installationShopVehicle.year,
    make: installationShopVehicle.make,
    model: installationShopVehicle.model,
    submodel: installationShopVehicle.submodel,
    engine: installationShopVehicle.engine,
  }), [installationShopVehicle.engine,
    installationShopVehicle.make,
    installationShopVehicle.model,
    installationShopVehicle.submodel,
    installationShopVehicle.year])

  // Saves ref for GTM events, it should never send GTM events on the first effect.
  // The reason for this, is that in the first effect, we still have the previous state
  // therefore the events send have the wrong value
  const effectCount = useRef(0)

  useEffect(() => {
    if (!isInstallationAdded && partName) {
      effectCount.current += 1
      if (effectCount.current === 1) {
        return
      }
      if (isRepairPalPricingEnabled && priceType === 'range') {
        installAtShopWidgetLoaded('Cart' as DifmLocation, partName, sku)
        rppPriceRange('Cart', partName, serializedVehicle)
      } else if (priceType === 'single') {
        installAtShopWidgetLoaded('Cart' as DifmLocation, partName, sku)
        rppSinglePrice('Cart', partName, serializedVehicle)
      }
    }
  // serializedVehicle was left out of the dependencies, since we don't want to send another GTM event before having new prices
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInstallationAdded, isRepairPalPricingEnabled, partName, priceType, sku])

  useValidateShopTimeslotsForItemVehicle(installationShop, installationShopVehicle, skuETA, onRemoveFromCart)

  const isFirstAvailability = isFirstAvailableTimeslot(difmState.timeslots.availableTimeslots, installationShop?.installDateTimeUtc)

  if (!isDifmEnabled || !isAllowedForDifm) {
    setDifmAttr(0, installationShopVehicle.partName)
    return null
  }

  if (!installationShopVehicle?.make) {
    setDifmAttr(1, installationShopVehicle.partName)

    return (
      <InstallAtShopNoVehicle
        addVehicleTrigger={addVehicleTrigger}
        showBorder={false}
        showTopDivider
        page="Cart"
        product={cartItemData?.product}
      />
    )
  }

  if (!installationShop && !suggestedShops?.isLoading) {
    setDifmAttr(0, installationShopVehicle.partName)
    return <InstallationQuotes skuTitle={sku} show location="cart" />
  }

  if (!installationShopFromCart && suggestedShops?.isLoading) {
    return <SkeletonLoaderInstallAtShopCart />
  }

  if (!installationShop || !installationShop.installDateTimeUtc || Number.isNaN(installationShop.installDateTimeUtc?.getTime())) {
    setDifmAttr(0, installationShopVehicle.partName)
    // hide widget when shop don't have a valid installDateTime
    return <InstallationQuotes skuTitle={sku} show location="cart" />
  }

  setDifmAttr(1, installationShopVehicle.partName)

  return (
    <InstallAtShopInfo
      installationShop={installationShop}
      showNationalAvgCost={false}
      sku={sku}
      pageName="Cart"
      partName={installationShopVehicle.partName}
      isFirstAvailability={isFirstAvailability}
      onRemoveInstallation={onRemoveFromCart}
      onAddInstallation={onAddFromCart}
      onChangeInstallation={onChangeFromCart}
      onOpenVehicleDetails={onChangeFromCart}
      withPostalCode
    />
  )
}

export default InstallAtShopCart
/* eslint-enable import/max-dependencies */
/* eslint-enable max-lines */
